import LazyImg from '@/components/common/LazyImg';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';
import cls from 'classnames';
import styles from './New.module.scss';
import { categories, categoriesColors } from '@/constants/news/category';

interface Props {
  time: ReactNode;
  category: ReactNode;
  title: ReactNode;
  cover: string;
}

const NewCp: React.FC<Props> = ({ category, cover, title, time }) => {
  const { locale } = useRouter();

  return (
    <div className={styles.new__container}>
      <div className={styles.image}>
        <LazyImg src={cover} width="378" height="212" alt="" />
      </div>
      <div className={styles.new__content}>
        <div
          style={{ ...categoriesColors[category as string] }}
          className={styles.label}
        >
          <span>{categories[category as string][locale]}</span>
        </div>
        <div className={styles.title}>
          <span className={cls({ en: locale === 'en-US' })}>{title}</span>
        </div>
        <div className={styles.time}>
          <span className={styles.time__svg}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="7" cy="7" r="6.5" stroke="#9C9EA6" />
              <rect
                x="6.5"
                y="2.5"
                width="1"
                height="5"
                rx="0.5"
                fill="#9C9EA6"
              />
              <rect
                width="1"
                height="5"
                rx="0.5"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 6.5 6.5)"
                fill="#9C9EA6"
              />
            </svg>
          </span>
          {time}
        </div>
      </div>
    </div>
  );
};

export default NewCp;
